import { useMemo } from "react";
import moment from "moment";
import { formatDateMonthYear } from "utils/helpers/format";

const useCompanyData = (fetchData) => {
  const data = fetchData;
  console.log({ data });

  const formattedData = useMemo(() => {
    const rows = [];

    if (data?.data && Array.isArray(data?.data)) {
      data?.data?.forEach((item, index) => {
        if (item) {
          // const company = item.Company || {};
          // const packageType = item.Package_type || {};

          // console.log("packageType", packageType);

          // const row = {
          //   id: index,
          //   company_package_id: item.company_package_id,
          //   package_type_id: item.package_type_id,
          //   approved: item.approved,
          //   description: item.description || "",
          //   company_status: item.status || "",
          //   date_start: moment(item.date_start).format(
          //     "DD/MM/YYYY\nเวลา HH:mm:ss น."
          //   ),
          //   date_expire: moment(item.date_expire).format(
          //     "DD/MM/YYYY\nเวลา HH:mm:ss น."
          //   ),
          //   created_date: moment(item.created_date).format(
          //     "DD/MM/YYYY\nเวลา HH:mm:ss น."
          //   ),
          //   updated_date: moment(item.updated_date).format(
          //     "DD/MM/YYYY\nเวลา HH:mm:ss น."
          //   ),
          //   company_id: company.company_id || "",
          //   company_name: company.company_name || "",
          //   mid: company.mid || "",
          //   contact: company.contact || "",
          //   phone: company.phone || "",
          //   package_type: packageType.name_package || "",
          // };

          const packages = item.packages || {};
          let pawn = null;
          let car = null;
          let land = null;

          packages?.forEach((pack) => {
            if (pack.name === "ระบบโรงรับจำนำ หรือร้านค้าทั่วไป") {
              pawn = pack;
            } else if (pack.name === "ระบบรถมือสอง") {
              car = pack;
            } else if (pack.name === "ระบบที่ดิน") {
              land = pack;
            }
          });

          const row = {
            ...item,
            id: item.company_id || index,
            package_pawn: pawn,
            package_car: car,
            package_land: land,
            company_status: item.status || "",
          };

          rows.push(row);
        }
      });
    }

    console.log("formattedData", rows);

    return rows;
  }, [data]);

  return formattedData;
};

export default useCompanyData;
